import { render, staticRenderFns } from "./_detail_tab_zsm.vue?vue&type=template&id=1cc817b8&scoped=true&"
import script from "./_detail_tab_zsm.vue?vue&type=script&lang=js&"
export * from "./_detail_tab_zsm.vue?vue&type=script&lang=js&"
import style0 from "./_detail_tab_zsm.vue?vue&type=style&index=0&id=1cc817b8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cc817b8",
  null
  
)

export default component.exports